module.exports = __webpack_public_path__ + "img/Trust (2).27a96b76.svg";